import { Component, OnInit, ElementRef, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-dashboard-devices-status-zoom-card',
  templateUrl: './dashboard-devices-status-zoom-card.component.html',
  styleUrls: ['./dashboard-devices-status-zoom-card.component.scss']
})
export class DashboardDevicesStatusZoomCardComponent implements OnInit, AfterViewInit {

  @ViewChild('devicesStatus', { static: false }) devicesStatusRef: ElementRef;
  ctx;
  myChart;
  title;
  colors;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<MatDialog>) { }

  ngOnInit() {
    this.title = this.data.title;
    this.colors = this.data.colors;
  }

  ngAfterViewInit() {
    this.ctx = this.devicesStatusRef.nativeElement.getContext('2d');
    this.renderChart(this.data.data);
  }

  public close() {
    this.dialogRef.close();
  }

  private renderChart(data) {
    const o = {
      TOTAL: 0,
      ONLINE: 0,
      OFFLINE: 0,
      DISABLED: 0
    };
    data.forEach(s => o[s.label] = s.count);
    o.TOTAL = o.ONLINE + o.OFFLINE + o.DISABLED;

    if (this.myChart) {
      this.myChart.destroy();
    }
    this.myChart = new Chart(this.ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: [
            o.ONLINE,
            o.DISABLED,
            o.OFFLINE
          ],
          backgroundColor: [
            this.colors[3],
            this.colors[6],
            this.colors[1]
          ],
          hoverBackgroundColor: [
            this.colors[3] + 'EE',
            this.colors[6] + 'EE',
            this.colors[1] + 'EE'
          ],
          borderColor: [
            this.colors[3],
            this.colors[6],
            this.colors[1]
          ],
          hoverBorderColor: [
            this.colors[3] + 'EE',
            this.colors[6] + 'EE',
            this.colors[1] + 'EE'
          ],
        }
        ],
        labels: ['ONLINE', 'DISABLED', 'OFFLINE']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          display: true,
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa'
        }
      },
      plugins: [{
        id: 'total',
        font: {
          size: 14
        },
        beforeDraw: (chart) => {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            ctx.fillStyle = '#aaaaaa';
            const text12 = 'TOTAL';
            ctx.font = '14px sans-serif';
            ctx.fillText(text12, width / 2 - (ctx.measureText(text12).width / 2), height / 2 - 70);
            const text11 = o.TOTAL;
            ctx.font = '34px sans-serif';
            ctx.fillText(text11, width / 2 - (ctx.measureText(text11).width / 2), height / 2 - 30);

            ctx.fillStyle = this.colors[3];
            ctx.font = '22px sans-serif';
            const text21 = o.ONLINE;
            ctx.fillText(text21, width / 2 - (ctx.measureText(text21).width / 2 + 45), height / 2 + 15);
            ctx.font = '10px sans-serif';
            const text22 = 'ONLINE';
            ctx.fillText(text22, width / 2 - (ctx.measureText(text22).width / 2 + 45), height / 2 + 35);

            ctx.fillStyle = this.colors[1];
            ctx.font = '22px sans-serif';
            const text31 = o.OFFLINE;
            ctx.fillText(text31, width / 2 - (ctx.measureText(text31).width / 2), height / 2 + 65);
            ctx.font = '10px sans-serif';
            const text32 = 'OFFLINE';
            ctx.fillText(text32, width / 2 - (ctx.measureText(text32).width / 2), height / 2 + 85);
            ctx.save();

            ctx.fillStyle = this.colors[6];
            ctx.font = '22px sans-serif';
            const text41 = o.DISABLED;
            ctx.fillText(text41, width / 2 - (ctx.measureText(text41).width / 2 - 45), height / 2 + 15);
            ctx.font = '10px sans-serif';
            const text42 = 'DISABLED';
            ctx.fillText(text42, width / 2 - (ctx.measureText(text42).width / 2 - 45), height / 2 + 35);
            ctx.save();
        }
      }]
    });
  }
}
